import { styled } from 'styled-components';

export const ClassificationButtonsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)}px;
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
`;
